<template>
  <div
    class="style1"
    :class="{
      must: fieldObj.required == 1,
      err: fieldObj.dirty && fieldObj.invalid,
      statusNoBorder: fieldStyle == 'style2'
    }"
  >
    <div class="u-label">
      {{ fieldObj.displayName }}
    </div>
    <div class="m-checkbox-list">
      <a-checkbox
        v-for="(o, i) in fieldObj.listOptions"
        :key="o.optionId"
        class="m-checkbox-item"
        :class="{
          'has-desc':
            fieldObj.options &&
            fieldObj.options[i] &&
            (fieldObj.options[i].optionDescText ||
              fieldObj.options[i].optionDescHrefText)
        }"
        @change="handleChange"
        :value="o.optionId"
        :disabled="fieldObj.disabled || o.disabled"
        v-model="o.checked"
      >
        {{ o.optionValue }}
        <input
          class="otherInput"
          v-if="o.otherisFillIn == 1"
          :disabled="!o.checked"
          type="text"
          v-model="o.otherValue"
          @blur="inputBlur($event, o)"
        />
        <div
          v-if="
            fieldObj.options &&
              fieldObj.options[i] &&
              fieldObj.options[i].optionDescText
          "
          class="u-desc"
        >
          {{ fieldObj.options[i].optionDescText }}
        </div>
        <div
          v-if="
            fieldObj.options &&
              fieldObj.options[i] &&
              fieldObj.options[i].optionDescHrefText
          "
          class="u-desc"
        >
          <a :href="fieldObj.options[i].optionDescHref">{{
            fieldObj.options[i].optionDescHrefText
          }}</a>
        </div>
        <div
          class="u-reg-err-tips"
          v-if="
            o.checked &&
              o.otherisFillIn == 1 &&
              o.otherIsRequire == 1 &&
              !o.otherValue
          "
        >
          请填写
        </div>
      </a-checkbox>
    </div>
    <div class="u-reg-err-tips" v-if="fieldObj.dirty && fieldObj.invalid">
      {{ fieldObj.validationMessage }}
    </div>
  </div>
</template>

<script>
import checkboxMixin from "../../field/new-fields/checkbox";
export default {
  name: "sk-checkbox",
  mixins: [checkboxMixin]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.hello {
  text-align: left;
  padding: 20px;
}
.otherInput:disabled {
  cursor: not-allowed;
  background-color: #e8e8e8;
  color: #999;
}
</style>
